// src/hooks/useDonationData.jsx
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { postApi } from "../../ApiServices/api";
import { apiEndPoints } from "../../ApiServices/config";
import { updateCart } from "../../actions";
import { useDispatch, useSelector } from "react-redux";

const useDonationData = () => {
  const params = useParams();
  const [donationData, setDonationData] = useState(null);
  const [donationAmount, setDonationAmount] = useState({});
  const [errorMessage, setErrorMessage] = useState("");
  const cartArr = useSelector((state) => state.cartArr);
  const dispatch = useDispatch();

  const getDonations = async () => {
    const response = await postApi(apiEndPoints.getDonationByCategory, {
      id: params.donationcategory,
    });
    if (response?.status === 200) {
      setDonationData(response?.data?.data);
    }
  };

  const handleDonationAmount = (item, e) => {
    const value = e.target.value;

    if (value === "" || value < item.amount) {
      setErrorMessage(
        value === ""
          ? "Please enter a donation amount"
          : `Minimum donation amount is $${item.amount}`
      );
    } else {
      setErrorMessage("");
    }

    setDonationAmount((prev) => ({
      ...prev,
      [item._id]: value,
    }));
  };
  
  const handleAddDonations = (item) => {
      const amount = donationAmount[item._id];
  
      if (!amount || amount < item.amount) {
        setErrorMessage(
          !amount
            ? "Please enter a donation amount"
            : `Minimum donation amount is $${item.amount}`
        );
        return;
      }
  
      const existingCartItem = cartArr.find(
        (cartItem) => cartItem._id === item._id
      );
  
      if (existingCartItem) {
        const updatedItem = {
          ...existingCartItem,
          amount: donationAmount[item._id],
        };
        dispatch(updateCart(updatedItem));
      } else {
        const newItem = {
          ...item,
          amount: donationAmount[item._id],
        };
        dispatch(updateCart(newItem));
      }
  
      setErrorMessage("");
    };

  useEffect(() => {
    getDonations();
  }, [params]);

  return {
    donationData,
    donationAmount,
    errorMessage,
    handleDonationAmount,
    handleAddDonations,
  };
};

export default useDonationData;
